export const FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_SHOW = 'FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_SHOW';
export const FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_HIDE = 'FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_HIDE';
export const FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_CHECK_HEADER = 'FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_CHECK_HEADER';
export const FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_CHANGE = 'FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_CHANGE';
export const FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_SUBMIT = 'FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_SUBMIT';

export const showSelectSort = () => ({
  type: FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_SHOW
});

export const hideSelectSort = () => ({
  type: FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_HIDE
});

export const checkHeadersSelectSort = header => ({
  type: FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_CHECK_HEADER,
  header
});

export const changeMergedHeaderSelectSort = cols => ({
  type: FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_CHANGE,
  cols
});

export const submitOrderedMergedList = () => ({
  type: FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_SUBMIT
})
  